import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { graphql } from 'gql';
import { useDebounce } from 'uikit';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const query = graphql(`
    query isUniqueProjectCode($uniqueId: String, $projectCode: String!) {
        isUniqueProjectCode(uniqueId: $uniqueId, projectCode: $projectCode) {
            buttonText
            code
            result
            message
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

interface IUniqueProjectCode {
    uniqueId?: string;
    projectCode: string | null;
    isProjectCodeDirty: boolean;
}

const requestId = 'isUniqueProjectCode';

export const useIsUniqueProjectCode = ({ projectCode, uniqueId, isProjectCodeDirty }: IUniqueProjectCode) => {
    const dispatch = useDispatch();

    const [data, status, errors, request] = useRequest({
        requestId,
        query,
        withEffect: false,
    });

    const debounceRequest = useDebounce((codeValue: string) => {
        dispatch(request({ projectCode: codeValue.trim(), uniqueId }));
    }, 500);

    const [makeResetIsUniqProjectCode] = useResetStoreData({ requestId });

    useEffect(() => {
        if (projectCode?.length && isProjectCodeDirty) {
            debounceRequest(projectCode);
        }
    }, [debounceRequest, isProjectCodeDirty, projectCode]);

    useEffect(
        () => () => {
            makeResetIsUniqProjectCode(undefined);
        },
        [makeResetIsUniqProjectCode],
    );

    return {
        isUniqueProjectCode: data?.isUniqueProjectCode?.result ?? true,
        status,
        errors,
    };
};
